module.exports = __webpack_public_path__ + "static/media/sort-caret-down.a95e75f8.svg";